var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEagle2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 381.89 214.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{stroke-miterlimit:10;}.cls-1,.cls-2{stroke-width:8px;}.cls-1,.cls-3{fill:#7da2fe;}.cls-1,.cls-3,.cls-4{stroke:#5d8bfe;}.cls-2{stroke:#386aff;}.cls-2,.cls-3,.cls-4{stroke-linecap:round;stroke-linejoin:round;}.cls-2,.cls-4{fill:none;}.cls-3,.cls-4{stroke-width:6px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "152.79 85.32 131.47 139.26 174.11 139.26 152.79 85.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M152.79,150.13h21.32c0,7.57-9.62,13.81-21.32,13.81s-21.32-6.23-21.32-13.81h21.32Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "228.41 85.32 207.1 139.26 249.73 139.26 228.41 85.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M228.41,150.13h21.32c0,7.57-9.62,13.81-21.32,13.81s-21.32-6.23-21.32-13.81h21.32Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M176.29,37.38v-14.37c0-10.5,8.51-19.01,19.01-19.01h12.69c4.55,0,8.87,1.99,11.83,5.45l4.92,5.76s-19.12-1.93-19.12,22.18"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 238.88,
    y1: 4.12,
    x2: 377.89,
    y2: 4.12
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M205.6,37.61c0,18.37,15.02,33.49,33.28,33.49s33.28-15.12,33.28-33.49-15.02-33.49-33.28-33.49"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M205.6,37.61c0,18.37,15.02,33.49,33.28,33.49s33.28-15.12,33.28-33.49-15.02-33.49-33.28-33.49"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 377.89,
    y1: 4.12,
    x2: 266.46,
    y2: 4.12
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 358.03,
    y1: 19.71,
    x2: 276.17,
    y2: 15.57
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 338.17,
    y1: 35.31,
    x2: 281.17,
    y2: 28.39
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 318.31,
    y1: 50.9,
    x2: 281.86,
    y2: 42.61
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 298.45,
    y1: 66.49,
    x2: 277.15,
    y2: 57.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 278.59,
    y1: 82.08,
    x2: 265.32,
    y2: 72.01
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 258.73,
    y1: 97.67,
    x2: 248.97,
    y2: 79.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M238.88,71.1c18.26,0,33.28-15.12,33.28-33.49s-15.02-33.49-33.28-33.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M217.69,210.9h-54.18c0-4.49,3.64-8.12,8.12-8.12h37.94c2.24,0,4.27,.91,5.74,2.38,1.47,1.47,2.38,3.51,2.38,5.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M210.28,202.78h-39.36c0-4.49,2.64-8.12,5.9-8.12h27.56c1.63,0,3.1,.91,4.17,2.38,1.07,1.47,1.73,3.51,1.73,5.75Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 190.6,
    cy: 69.51,
    r: 8.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 190.6,
    cy: 82.95,
    r: 5.22
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 143.02,
    y1: 4.12,
    x2: 4,
    y2: 4.12
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M176.29,37.61c0,18.37-15.02,33.49-33.28,33.49s-33.28-15.12-33.28-33.49S124.76,4.12,143.02,4.12"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M176.29,37.61c0,18.37-15.02,33.49-33.28,33.49s-33.28-15.12-33.28-33.49S124.76,4.12,143.02,4.12"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 4,
    y1: 4.12,
    x2: 115.43,
    y2: 4.12
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 23.86,
    y1: 19.71,
    x2: 105.72,
    y2: 15.57
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 43.72,
    y1: 35.31,
    x2: 100.72,
    y2: 28.39
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 63.58,
    y1: 50.9,
    x2: 100.03,
    y2: 42.61
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 83.44,
    y1: 66.49,
    x2: 104.74,
    y2: 57.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 103.3,
    y1: 82.08,
    x2: 116.57,
    y2: 72.01
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 123.16,
    y1: 97.67,
    x2: 132.92,
    y2: 79.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M143.02,71.1c-18.26,0-33.28-15.12-33.28-33.49S124.76,4.12,143.02,4.12"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 186.7,
    y: 69.51,
    width: 7.81,
    height: 135.75
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 190.6,
    cy: 69.51,
    r: 10.12
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 190.6,
    cy: 86.06,
    r: 6.43
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEagle2);
export default __webpack_public_path__ + "static/media/eagle2.2682255c32d4a3406e1b201986b2f527.svg";
export { ForwardRef as ReactComponent };